module.exports = __webpack_public_path__ + "media/images/front/products/sonimage_hs2/body-a95cf7232331ee23e0d9f967af14410a.png";